/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

import { Element } from './Element';
import { Hit } from './Hit';
import { MathUtils } from './MathsUtils';
import { Vector2 } from 'three';

export class ElementBox implements Element {
  private specialty: string;

  private corner1: Vector2;
  private corner2: Vector2;
  private corner3: Vector2;
  private corner4: Vector2;

  private norm1: Vector2;
  private norm2: Vector2;
  private norm3: Vector2;
  private norm4: Vector2;

  constructor(elem: any, ballRadius: number) {
    this.specialty = elem.specialty;
    const from = new Vector2(elem.from[0], elem.from[1]);
    const to = new Vector2(elem.to[0], elem.to[1]);

    this._calcBoxGeometry(from, to, elem.width);

  }

  checkHit (point: Vector2, dir: Vector2, ballRadius: number): Hit {
    let hit = this.checkSingleLine(point, dir, this.corner1, this.corner2, this.norm1, ballRadius);
    hit = Hit.improve(hit, this.checkSingleLine(point, dir, this.corner2, this.corner3, this.norm2, ballRadius));
    hit = Hit.improve(hit, this.checkSingleLine(point, dir, this.corner3, this.corner4, this.norm3, ballRadius));
    hit = Hit.improve(hit, this.checkSingleLine(point, dir, this.corner4, this.corner1, this.norm4, ballRadius));

    hit = Hit.improve(hit, MathUtils.checkCircleHit(point, dir, this.corner1, ballRadius));
    hit = Hit.improve(hit, MathUtils.checkCircleHit(point, dir, this.corner2, ballRadius));
    hit = Hit.improve(hit, MathUtils.checkCircleHit(point, dir, this.corner3, ballRadius));
    hit = Hit.improve(hit, MathUtils.checkCircleHit(point, dir, this.corner4, ballRadius));

    return hit;
  }

  private _calcBoxGeometry (from: Vector2, to: Vector2, width: number) {
    const side = MathUtils.sub(to, from);
    const norm = new Vector2(-side.y, side.x).normalize();

    this.corner1 = from.clone().add(norm.clone().multiplyScalar(width / 2));
    this.corner2 = this.corner1.clone().add(side);
    this.corner3 = this.corner2.clone().add(norm.clone().multiplyScalar(-width));
    this.corner4 = this.corner1.clone().add(norm.clone().multiplyScalar(-width));

    this.norm1 = norm;
    this.norm2 = new Vector2(norm.y, -norm.x);
    this.norm3 = new Vector2(-norm.x, -norm.y);
    this.norm4 = new Vector2(-norm.y, norm.x);
  }

  private checkSingleLine (point: Vector2, dir: Vector2, p1: Vector2, p2: Vector2, norm: Vector2, scale: number): Hit {
    const hit = new Hit(new Vector2(), new Vector2(), -1);
    if (norm.dot(dir) < 0) {
      const offset = norm.clone().multiplyScalar(scale);
      const t = MathUtils.calcRayLine(point, dir, p1.clone().add(offset), p2.clone().add(offset));
      if (t > 0) {
        hit.len = t;
        hit.point = point.clone().add(dir.clone().multiplyScalar(t));
        hit.dir = MathUtils.reflect(dir, norm);
      }
    }
    return hit;
  }

}
